import { flow } from "fp-ts/lib/function";

import { MetricField } from "../../gql-generated/types";
import { type InsightsMetrics, type InsightsMetricsMap, type StatsItem } from "../models";

import { mapAverageStatAverageValue } from "./mapAverageStatAverageValue";
import { mapAverageStatDiffValue } from "./mapAverageStatDiffValue";
import { mapAverageStatValueOverTime, mapAverageStatValueOverTimeFormatted } from "./mapAverageStatValueOverTime";
import { type TotalsMap } from "./mapFieldsToLifetimeTotalValues";

export const mapAverageStatData = (
    metrics: InsightsMetricsMap<StatsItem>,
    metricsPrevious: InsightsMetricsMap<StatsItem>,
    averageStatObj: InsightsMetrics<StatsItem> | undefined,
    baseMetricField: MetricField,
    lifetimeTotals?: TotalsMap,
): InsightsMetrics<StatsItem> | undefined => {
    const lensPlays =
        (lifetimeTotals ? lifetimeTotals[MetricField.LensPlays] : metrics[MetricField.LensPlays]?.totalValue) ?? 0;
    const lensPlaysPrev = metricsPrevious[MetricField.LensPlays]?.totalValue ?? 0;

    const stat = (lifetimeTotals ? lifetimeTotals[baseMetricField] : metrics[baseMetricField]?.totalValue) ?? 0;
    const statPrev = metricsPrevious[baseMetricField]?.totalValue ?? 0;

    if (!averageStatObj) {
        return undefined;
    }

    return flow(
        mapAverageStatAverageValue,
        mapAverageStatValueOverTime({ lensPlays, stat }), // sets valueOverTime
        mapAverageStatValueOverTimeFormatted, // sets valueOverTimeFormatted
        mapAverageStatDiffValue(
            [
                { lensPlays, stat },
                { lensPlays: lensPlaysPrev, stat: statPrev },
            ],
            !!lifetimeTotals,
        ), // sets diffValue
    )(averageStatObj);
};
